module.exports = __webpack_public_path__ + "img/product_banner.c13fc446.jpg";